import React, { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Switch,
  InputAdornment,
  Button,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import FilterAltIcon from "@mui/icons-material/FilterAlt";

const FieldSett = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [data, setData] = useState([
    { name: "Alwyn Pereira", id: "1", department: "-", number: "9663478258", enabled: true },
    { name: "Arun V Nath", id: "-", department: "-", number: "9094730140", enabled: true },
    { name: "Ashish Kumar", id: "-", department: "-", number: "1965078079", enabled: false },
    { name: "Bharath Kumar", id: "2", department: "-", number: "9964070355", enabled: true },
    { name: "Chandru V", id: "11", department: "-", number: "8124908052", enabled: true },
    { name: "Charan Gowda", id: "6", department: "-", number: "7019876885", enabled: true },
    { name: "Charles", id: "7", department: "-", number: "7010660756", enabled: true },
    { name: "Gokul Raj", id: "16", department: "-", number: "9566106451", enabled: true },
    { name: "Hari", id: "20", department: "-", number: "8148680633", enabled: true },
  ]);

  const handleToggle = (index) => {
    const updatedData = [...data];
    updatedData[index].enabled = !updatedData[index].enabled;
    setData(updatedData);
    console.log(`Toggled ${updatedData[index].name}:`, updatedData[index].enabled);
  };

  return (
    <Box sx={{ p: 3, backgroundColor: "#f8f9fa" }}>
      {/* Title */}
      <Typography variant="h5" sx={{ fontWeight: "bold", color: "#333", mb: 1 }}>
        Staff Location Access
      </Typography>
      <Typography variant="body2" sx={{ color: "#666", mb: 3 }}>
        Staff you have added in your Web subscription will appear here
      </Typography>

      {/* Search Bar */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          mb: 3,
        }}
      >
        <TextField
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          placeholder="Search By Name/ID"
          variant="outlined"
          fullWidth
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          sx={{
            "& .MuiOutlinedInput-root": {
              border: "1px solid gray",
              borderRadius: "5px",
              "&:hover fieldset": { borderColor: "black" },
              "&.Mui-focused fieldset": { borderColor: "black" },
            },
            "& .MuiInputBase-input": {
              color: "black",
            },
          }}
        />
        {/* <Button
          variant="outlined"
          startIcon={<FilterAltIcon />}
          sx={{
            borderColor: "#2196f3",
            color: "#2196f3",
            "&:hover": { borderColor: "#1976d2", color: "#1976d2" },
          }}
        >
          Filter
        </Button> */}
      </Box>

      {/* Table */}
      <TableContainer component={Paper} sx={{ backgroundColor: "white" }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: "bold", color: "black" }}>Name</TableCell>
              <TableCell sx={{ fontWeight: "bold", color: "black" }}>ID</TableCell>
              <TableCell sx={{ fontWeight: "bold", color: "black" }}>Department</TableCell>
              <TableCell sx={{ fontWeight: "bold", color: "black" }}>Phone Number</TableCell>
              <TableCell sx={{ fontWeight: "bold", color: "black" }}>Enable/Disable</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row, index) => (
              <TableRow key={index}>
                <TableCell sx={{ color: "black" }}>{row.name}</TableCell>
                <TableCell sx={{ color: "black" }}>{row.id}</TableCell>
                <TableCell sx={{ color: "black" }}>{row.department}</TableCell>
                <TableCell sx={{ color: "black" }}>{row.number}</TableCell>
                <TableCell>
                  <Switch
                    checked={row.enabled}
                    onChange={() => handleToggle(index)}
                    sx={{
                      "& .MuiSwitch-thumb": { color: row.enabled ? "#2196f3" : "gray" },
                      "& .MuiSwitch-track": { backgroundColor: row.enabled ? "#2196f3" : "gray" },
                    }}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default FieldSett;
